import { Action, Communicator, setupPostQuecast } from "@wikia/post-quecast";
import { inject, singleton } from "tsyringe";
import { WINDOW } from "@identity/symbols";

interface PostQuecastSettings {
  channelId?: string;
  coordinatorName?: string;
}

const SETTINGS_KEY = "@wikia/post-quecast-settings";

@singleton()
export class CommunicationService {
  private readonly history = new Map<string, boolean>();
  private readonly communicator: Communicator;

  constructor(@inject(WINDOW) private window: Window) {
    const { channelId, coordinatorName } = this.getSettings();

    setupPostQuecast();
    this.communicator = new Communicator({
      channelId: channelId || "default",
      coordinatorHost: window[coordinatorName] || top,
    });
  }

  emit(action: Action): void {
    this.communicator.dispatch(action);
  }

  on(action: Action, callback: (payload?: any) => void): void {
    this.communicator.addListener((a: Action) => this.run(a, action, callback));
  }

  once(action: Action, callback: (payload?: any) => void): void {
    this.communicator.addListener((a: Action) =>
      this.runOnce(a, action, callback),
    );
  }

  private getSettings(): PostQuecastSettings {
    return this.window[SETTINGS_KEY] || {};
  }

  private run(
    action: Action,
    actionToListen: Action,
    callback: (payload?: any) => void,
  ): void {
    if (this.ofType(action, actionToListen)) {
      callback(action);
    }
  }

  private runOnce(
    action: Action,
    actionToListen: Action,
    callback: (payload?: any) => void,
  ): void {
    const key = actionToListen.category + " " + actionToListen.name;

    if (!this.ofType(action, actionToListen)) {
      return;
    }

    if (this.history.has(key)) {
      return;
    }

    this.history.set(key, true);

    callback(action);
  }

  private ofType(action: Action, actionToListen: Action): boolean {
    return (
      (action.category === actionToListen.category &&
        action.name === actionToListen.name) ||
      action.type === actionToListen.category + " " + actionToListen.name
    );
  }
}
